import { createContext, defaultValue, useContext } from 'react';

const ViewerControlContext = createContext(defaultValue);

export const ViewerControlProvider = ViewerControlContext.Provider;
export const useViewerControl = () => useContext(ViewerControlContext);
